<template>
  <div>
    <div
      v-for="(item, idx) in results"
      :key="idx"
      class="container-adjustment mt-4 mb-2"
    >
      <div class="row pl-5 pt-3 pb-1 pr-5">
        <div class="col-md-6">
          <div class="">
            <strong class="font-16">{{ item.reason }}</strong>
          </div>
        </div>
        <div class="col-md-6 d-flex justify-content-end">
          <strong v-if="item.amount > 0" class="font-16 positive">
            +${{ item.amount }}
          </strong>
          <strong v-else class="font-16 negative">
            -${{ item.amount * -1 }}
          </strong>
        </div>
      </div>
      <hr class="ml-3 mr-3" />
      <div class="row pl-5 pr-5">
        <div class="col-md-3 col-sm-12">
          <span class="data-title d-block border-mobile">Tipo:</span>
          <p class="font-16">{{ item.adjustmentType }}</p>
        </div>
        <div class="col-md-3 col-sm-12">
          <span class="data-title d-block border-mobile">Fecha:</span>
          <p class="font-16">
            {{ item.adjustmentDate | date('DD/MMM/YYYY hh:mm a') }}
          </p>
        </div>
        <div class="col-md-3 col-sm-12">
          <span class="data-title d-block border-mobile">Usuario:</span>
          <p class="font-16">{{ item.user }}</p>
        </div>
        <div
          v-if="item.studentName && item.studentName != '-'"
          class="col-md-3 col-sm-12"
        >
          <span class="data-title d-block border-mobile">
            Nombre del Estudiante:
          </span>
          <p class="font-16">{{ item.studentName }}</p>
        </div>
        <div
          v-if="
            item.proofId &&
              item.proofId != '00000000-0000-0000-0000-000000000000'
          "
          class="col-md-3 col-sm-12"
        >
          <span class="data-title d-block border-mobile">Evidencia:</span>
          <action-button
            id="actionBtnDownloadDocumentProof"
            i="fas fa-download pl-2 mt-1 mb-1"
            variant="success mr-5 mt-2 mb-2 pr-1 pl-1 pt-2 pb-2"
            @click="downloadDocument(item.proofId)"
          />
        </div>
        <div v-if="item.contractNumber" class="col-md-3 col-sm-12">
          <span class="data-title d-block border-mobile">
            Número de Contrato:
          </span>
          <p class="font-16">{{ item.contractNumber }}</p>
        </div>
        <div v-if="item.disciplineName" class="col-md-3 col-sm-12">
          <span class="data-title d-block border-mobile">Disciplina:</span>
          <p class="font-16">{{ item.disciplineName }}</p>
        </div>
        <div v-if="item.specialistName" class="col-md-3 col-sm-12">
          <span class="data-title d-block border-mobile">Especialista:</span>
          <p class="font-16">{{ item.specialistName }}</p>
        </div>
      </div>
      <div class="row pl-5 pr-5">
        <div v-if="item.otherReasons" class="col-12 col-md-10 align-col">
          <span class="data-title d-block border-mobile">Razón(es):</span>
          <p v-if="item.description" class="font-16">{{ item.otherReasons }}</p>
          <p v-else class="font-16">-</p>
        </div>
        <div class="col-12 col-md-10 align-col">
          <span class="data-title d-block border-mobile">Descripción:</span>
          <p v-if="item.description" class="font-16">{{ item.description }}</p>
          <p v-else class="font-16">-</p>
        </div>
        <div
          class="col-12 col-md-12 d-flex justify-content-md-end align-items-end"
        >
          <action-button
            v-if="!item.showPanel && showRemoveAdjustment"
            id="actionBtnDeleteAdjustment"
            class="bg-color-action"
            i="fas fa-minus-circle  pl-2"
            text="Eliminar"
            variant="outline-danger mr-0  mb-4 pr-3 pl-2 pt-2 pb-2"
            @click="removeAdjustment(idx, item.id)"
          />
        </div>
        <div
          class="col-md-12 d-flex justify-content-md-end align-items-start mt-4"
        >
          <!-- TODO: Add method and conditional for know the reason -->
          <action-button
            v-if="showCertificationConflict(item)"
            id="actionBtnDownloadConflictDocument"
            i="fas fa-download  pl-2"
            text="Descargar Certificación de Conflicto"
            variant="outline-success mr-0  mb-4 pr-3 pl-2 pt-2 pb-2"
            @click="downloadConflictDocument(idx, item.id)"
          />
          <div v-if="canDelete && showObjButton" class="ml-2">
            <action-button
              v-if="!item.showPanel && item.objectionComment"
              id="actionBtnCancelDocumentSigned"
              class="bg-color-action"
              i="fas fa-minus-circle  pl-2"
              text="Eliminar"
              variant="outline-danger mr-0  mb-4 pr-3 pl-2 pt-2 pb-2"
              @click="removeObjectionAdjustment(idx, item.id)"
            />
          </div>
          <action-button
            v-if="
              showObjButton &&
                !item.showPanel &&
                !item.objectionComment &&
                canObj
            "
            id="actionBtnObj"
            i="fas fa-gavel  pl-2"
            text="Objetar"
            variant="danger mr-0  mb-4 pr-3 pl-2 pt-2 pb-2"
            @click="openPanel(idx)"
          />
        </div>
      </div>

      <div
        v-if="!item.objectionStatusId && item.showPanel"
        class="objected-container ml-3 mr-3 mb-3 mt-4"
      >
        <icon-view
          class="pt-4 pl-4 ml-1 pb-4"
          :gradient="false"
          icon="fas fa-gavel "
          icon-background="#ff6f59"
          icon-color="white"
          icon-size="13px"
          title="Objeción de Ajuste"
        />
        <validation-observer ref="objectAdjust" v-slot="{}" tag="form">
          <div class="row ml-3 mr-3 pb-1">
            <div class="col-md">
              <span class="data-title d-block border-mobile">Comentario:</span>

              <validation-provider
                v-slot="{ errors }"
                name="adjustment-input-comment"
                rules="required"
              >
                <custom-input
                  id="bill-change-status-input-comment"
                  v-model="comment"
                  class="custom-input-con"
                  custom-error-msg="El comentario es requerido."
                  :error="errors[0]"
                  maxlength="3000"
                />
              </validation-provider>
            </div>
            <div class="col-md-4">
              <span class="data-title d-block border-mobile">Archivo:</span>
              <validation-provider
                v-slot="{ errors }"
                name="adjustment-input-file"
                rules="required"
              >
                <custom-file-input
                  id="customInptFileUploadDocumentsPdf"
                  ref="documentInputRef"
                  accept="pdf"
                  :attachment-id="item.objectionDocument?.objectionDocumentId"
                  class="file-input__extended"
                  custom-error-msg="El archivo es requerido."
                  display-style="normal"
                  :error="errors[0]"
                  :name="
                    attachment
                      ? ''
                      : item.objectionDocument?.objectionDocumentName
                  "
                  :on-download="
                    () =>
                      downloadDocument(
                        item.objectionDocument.objectionDocumentId
                      )
                  "
                  required
                  :value="attachment"
                  @input="(file) => onUploadFileHandler(file)"
                />
              </validation-provider>
            </div>
            <div class="col-12">
              <div class="align-button-group d-flex justify-content-end">
                <action-button
                  id="actionBtnCancelObjection"
                  i="fas fa-times-circle  pl-2"
                  text="Cancelar"
                  variant="outline-danger mr-2 mt-4 mb-4 pr-3 pl-2"
                  @click="closePanel(idx)"
                />
                <action-button
                  id="actionBtnSavedObjection"
                  i="fas fa-save fa-lg pl-2 mt-1 mb-1"
                  text="Guardar"
                  variant="success mt-4 mb-4  pr-3 "
                  @click="saveAdjust(idx, item)"
                />
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <div
        v-if="item.objectionComment"
        class="objected-container ml-3 mr-3 mt-3"
      >
        <div class="pl-4 pt-3">
          <div class="row">
            <div
              class="col-md-3 col-sm-12 col-lg-6 d-flex align-items-center font-16"
            >
              Ajuste Objetado por Proveedor
            </div>
            <div
              class="mx-auto col-md-6 col-sm-12 d-flex justify-content-end align-items-center"
            >
              <div v-if="isObjected(item) && showOkRject">
                <action-button
                  v-if="canAccept"
                  id="actionBtnOk"
                  class="font-16"
                  i="fas fa-plus-square  pl-2 mt-1 mb-1"
                  text="Aceptar"
                  variant="outline-success mt-2 mr-2  mb-2 pr-4 pl-3 pt-2 pb-2"
                  @click="accept(item)"
                />
                <action-button
                  v-if="canReject && !item.isRejectPanelOpen"
                  id="actionBtnReject"
                  i="fas fa-minus-square  pl-2 mt-1 mb-1"
                  text="Rechazar"
                  variant="outline-danger mt-2 mr-2  mb-2 pr-4 pl-3 pt-2 pb-2"
                  @click="toogleRejectPanel(idx)"
                />
              </div>

              <action-button
                v-if="(isReject(item) || isOk(item)) && canReturn"
                id="actionBtnOk"
                class="font-16"
                i="fas fa-undo  pl-2 mt-1 mb-1"
                text="Regresar Estatus"
                :variant="
                  item.objectionDocumentId
                    ? 'outline-success mt-2 mr-2  mb-2 pr-4 pl-3 pt-2 pb-2'
                    : 'outline-success mt-2 mr-5  mb-2 pr-4 pl-3 pt-2 pb-2'
                "
                @click="returnStatus(item)"
              />

              <action-button
                v-if="item.objectionDocumentId"
                id="actionBtnDownloadDocumentSigned"
                i="fas fa-download pl-2 mt-1 mb-1"
                variant="success mr-5 mt-2 mb-2 pr-1 pl-1 pt-2 pb-2"
                @click="
                  downloadDocument(item.objectionDocument.objectionDocumentId)
                "
              />
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-3">
              <span class="data-title d-block border-mobile">
                Fecha de Sometido:
              </span>
              <p class="font-16">
                {{ item.objectionDate | date('DD/MMM/YYYY hh:mm a') }}
              </p>
            </div>
            <div class="col-md-2">
              <div class="ml-4">
                <span class="data-title d-block border-mobile">Estado:</span>
                <div class="d-flex">
                  <div v-if="isObjected(item)" class="d-flex">
                    <span class="dot color-dot-smtda mr-2 mt-2" />
                    <p class="font-16">Sometido</p>
                  </div>
                  <div v-if="isReject(item)" class="d-flex">
                    <span class="dot color-dot-reject mr-2 mt-2" />
                    <p class="font-16">Rechazada</p>
                  </div>
                  <div v-if="isOk(item)" class="d-flex">
                    <span class="dot color-dot-ok mr-2 mt-2" />
                    <p class="font-16">Aceptada</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!isObjected(item)" class="col-md-4">
              <span class="data-title d-block border-mobile">
                Fecha de Determinación:
              </span>
              <p class="font-16">
                {{ item.updatedDate | date('DD/MMM/YYYY hh:mm a') }}
              </p>
            </div>
            <div class="col-md-9" />
          </div>
          <div class="row mt-3">
            <div class="col-md-7">
              <span class="data-title d-block border-mobile">Comentario:</span>
              <p class="font-16">
                {{ item.objectionComment }}
              </p>
            </div>

            <div class="col-md-9" />
          </div>
          <div v-if="isReject(item)" class="row mt-3">
            <div class="col-md-7">
              <span class="data-title d-block border-mobile">
                Razón de rechazo:
              </span>
              <p class="font-16">
                {{ item.rejectionComment || '-' }}
              </p>
            </div>

            <div class="col-md-9" />
          </div>
          <div v-if="item.isRejectPanelOpen" class="row pr-3">
            <div class="col-md-12">
              <validation-observer ref="rejectionValidator" v-slot="{}">
                <span class="data-title d-block mb-2">
                  Comentario de Rechazo:
                </span>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-text-area
                    v-model="item.rejectionComment"
                    :count-classes="['float-right']"
                    custom-error-msg="El comentario es requerido."
                    :error="errors[0]"
                    :maxlength="3000"
                    show-char-count
                  />
                </validation-provider>
              </validation-observer>
            </div>
            <div class="col-md-12">
              <action-button
                class="float-right ml-2"
                i="fas fa-save fa-lg"
                text="Guardar"
                variant="success mt-3"
                @click="reject(item)"
              />
              <action-button
                class="float-right"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger mb-4 mt-3"
                @click="toogleRejectPanel(idx)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="p-2" />
    </div>
  </div>
</template>
<script>
import objectToFormData from 'object-to-formdata';
import ActionButton from 'ActionButton';
import billingStatus from '@/utils/constants/billingStatus';
import CustomInput from 'CustomInput';
import CustomFileInput from 'CustomFileInput';
import CustomTextArea from 'CustomTextArea';
import IconView from 'icon-view';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import {
  submitObjection,
  submitAjusmentAcepted,
  removeObjection,
  removeAdjustment as _removeAdjustment,
} from '@/services/provider/billing-history.api';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import ReportServices from '@/services/common/report.api.js';
const statusResult = {
  SOMETIDA: 1,
  ACEPTADA: 2,
  RECHAZADA: 3,
};
export default {
  name: 'ResultRowAdjustment',
  components: {
    ActionButton,
    CustomInput,
    CustomFileInput,
    IconView,
    CustomTextArea,
  },
  mixins: [alertMixin],
  mounted() {
    this.addDataToResult();
  },
  props: {
    data: {
      type: Array,
      default: () => null,
    },
    billId: {
      type: Number,
      default: () => null,
    },
    billStatus: {
      type: Number,
      default: () => null,
    },
  },
  computed: {
    showObjButton() {
      return this.billStatus == billingStatus.PendienteRevision;
    },
    showOkRject() {
      return this.billStatus == billingStatus.EnProcesoIntervencionObjetada;
    },
    showRemoveAdjustment() {
      return this.billStatus == billingStatus.EnProcesoIntervencion;
    },
    isObjected() {
      return (item) => {
        return item.objectionStatusId === statusResult.SOMETIDA;
      };
    },
    isReject() {
      return (item) => {
        return item.objectionStatusId === statusResult.RECHAZADA;
      };
    },
    isOk() {
      return (item) => {
        return item.objectionStatusId === statusResult.ACEPTADA;
      };
    },
    canObj() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.object.adjustment'
      );
    },
    canAccept() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.approveadjustment'
      );
    },
    canReject() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.denyadjustment'
      );
    },
    canReturn() {
      return (
        this.billStatus == billingStatus.EnProcesoIntervencionObjetada &&
        this.userHasPermissions(
          'rempro.providers.billinghistory.returnadjustment'
        )
      );
    },
    canDelete() {
      return this.userHasPermissions(
        'rempro.providers.billinghistory.delete.objection'
      );
    },
    showCertificationConflict() {
      return (item) => {
        return (
          item.reasonId === 205 &&
          item.objectionStatusId !== statusResult.ACEPTADA //TODO: Change this condition to the correct one is not accepted
        );
      };
    },
  },
  data() {
    return {
      comment: null,
      attachment: null,
      results: [],
    };
  },
  methods: {
    addDataToResult() {
      this.results = [];
      for (let key in this.data) {
        this.results.push(this.data[key]);
        this.$set(this.data[key], 'showPanel', false);
        this.$set(this.data[key], 'isRejectPanelOpen', false);
      }
    },
    openPanel(idx) {
      this.results[idx].showPanel = true;
    },
    closePanel(idx) {
      this.results[idx].showPanel = false;
      this.comment = null;
    },
    onDownloadFile() {},
    async updateAdjustment(item, newStatus, rejectionComment = null) {
      let dataToSend = {
        billId: this.billId,
        billingAdjustmentId: item.id,
        newObjectionStatusId: newStatus,
        rejectionComment: rejectionComment,
      };

      await submitAjusmentAcepted(dataToSend).then(async () => {
        await this.$emit('reload-info');
        this.addDataToResult();
      });
    },
    async accept(item) {
      await this.updateAdjustment(item, statusResult.ACEPTADA);
    },
    toogleRejectPanel(idx) {
      this.results[idx].isRejectPanelOpen = !this.results[idx]
        .isRejectPanelOpen;
      if (this.results[idx].isRejectPanelOpen == false) {
        this.results[idx].rejectionComment = null;
      }
    },
    async reject(item) {
      var isValid = await this.$refs.rejectionValidator[0].validate();
      if (isValid) {
        this.updateAdjustment(
          item,
          statusResult.RECHAZADA,
          item.rejectionComment
        ).then(() =>
          this.ShowToast(
            'Proceso Exitoso.',
            'La objeción ha sido rechazada exitosamente.',
            'success'
          )
        );
      }
    },
    async returnStatus(item) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea regresar al estatus anterior?`,
        'Sí',
        'No'
      );

      if (answer) {
        this.updateAdjustment(item, statusResult.SOMETIDA).then(() => {
          this.ShowToast(
            'Proceso Exitoso.',
            'El estatus se ha actualizado exitosamente.',
            'success'
          );
        });
      }
    },
    downloadDocument(id) {
      _downloadDocumentByAttachmentId(id).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
    },
    downloadConflictDocument(index, id) {
      ReportServices.getConflictCorporationCertificate(id).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
    },
    async saveAdjust(idx, item) {
      const isValid = await this.$refs.objectAdjust[0].validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      let data = {
        BillingAdjustmentId: item.id,
        comment: this.comment,
        attachment: this.attachment,
        contractDocumentId: item.objectionDocument?.objectionContractDocumentId,
        contractId: item.objectionDocument?.contractId,
        academicYearId: item.objectionDocument?.academicYearId,
      };

      let dataTosend = objectToFormData(data, {
        indices: true,
        nullsAsUndefineds: true,
      });

      await submitObjection(dataTosend);
      this.closePanel(idx);
      await this.$emit('reload-info');
      this.addDataToResult();
    },
    async removeObjectionAdjustment(idx, id) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea eliminar la objeción seleccionada?`,
        'Sí',
        'No'
      );

      if (answer) {
        await removeObjection(id);
        this.closePanel(idx);
        await this.$emit('reload-info');
        this.ShowToast(
          'Proceso Exitoso.',
          'La objeción ha sido eliminada exitosamente.',
          'success'
        );
      }
    },
    async removeAdjustment(idx, id) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea eliminar el ajuste seleccionado?`,
        'Sí',
        'No'
      );

      if (answer) {
        await _removeAdjustment(id);
        this.closePanel(idx);
        await this.$emit('reload-info');
        this.ShowToast(
          'Proceso Exitoso.',
          'El ajuste ha sido eliminado exitosamente.',
          'success'
        );
      }
    },
    onUploadFileHandler(file) {
      this.attachment = file;
    },
  },
};
</script>

<style scoped lang="scss">
.container-adjustment {
  background-color: #f7f7f7;
  border-radius: 5px;
}
.negative {
  color: #c5525c;
}
.positive {
  color: #2db782;
}
.align-col {
  height: 49px;
}
.bg-color-action {
  background-color: #f7f7f7 !important;
}

.bg-color-action:hover {
  background-color: #c9545f !important;
}
.objected-container {
  background-color: white !important;
  border-radius: 5px;
}
.dot {
  height: 8px;
  width: 9px;

  border-radius: 50%;
  display: inline-block;
}
.color-dot-smtda {
  background-color: #f9e098;
}
.color-dot-reject {
  background-color: #c0565e;
}
.color-dot-ok {
  background-color: #44b584;
}

@import '~@/shared/scss/config/colors.scss';
.btn-action-size {
  width: 38px;
  height: 38px;
}

.file-replacement-input__extended {
  width: 38px !important;
  height: 38px !important;
  border-color: map-get($colors, 'green');
}
</style>
